<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <ubraniaMenu></ubraniaMenu>

        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Zestawy asekuracyjne</h4>
              <button v-if="hasPermission('canEditUbrania')" @click="openModal()" class="btn btn-primary btn-sm me-3">
                <i class="bi bi-plus-circle me-2"></i>Utwórz zestaw
              </button>
              <Link :href="route('bhp.zestawy.asekuracyjne.elementy')" class="btn btn-outline-primary btn-sm me-3">
                <i class="bi bi-arrow-right-circle me-2"></i>Elementy zestawów
              </Link>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div class="col-md-12 mb-4">
            <div class="table-responsive">
              <table class="table table-bordered table-hover text-center">
                <thead>
                <tr>
                  <th class="bg-gray-100 text-center">Zestaw nr</th>
                  <th class="bg-gray-100 text-center">Pracownik/Dział</th>
                  <th class="bg-gray-100 text-center">Nr serii szelek</th>
                  <th class="bg-gray-100 text-center">Data produkcji szelek</th>
                  <th class="bg-gray-100 text-center">Nr serii liny</th>
                  <th class="bg-gray-100 text-center">Data produkcji liny</th>
                  <th class="bg-gray-100 text-center">Nr serii zatrzaśnika</th>
                  <th class="bg-gray-100 text-center">Data produkcji zatrzaśnika</th>
                  <th class="bg-gray-100 text-center">Data przeglądu</th>
                  <th class="bg-gray-100 text-center">Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="zestaw in zestawy" :key="zestaw.id">
                  <td>{{ zestaw.id }}</td>
                  <td class="text-start">
                      <span @click="openAssignModal(zestaw)" style="cursor:pointer;">
						{{ zestaw.assigned_to || 'Zapasowy' }}<br>{{ zestaw.assigned_who_tekst || '' }}
                      </span>
                  </td>
                  <td>{{ zestaw.szelki?.nr_seryjny }}</td>
                  <td>{{ formatDate(zestaw.szelki?.data_produkcji) }}</td>
                  <td>{{ zestaw.lina?.nr_seryjny }}</td>
                  <td>{{ formatDate(zestaw.lina?.data_produkcji) }}</td>
                  <td>{{ zestaw.zatrzasnik?.nr_seryjny }}</td>
                  <td>{{ formatDate(zestaw.zatrzasnik?.data_produkcji) }}</td>
                  <td>{{ formatDate(zestaw.last_przeglad) }}</td>
                  <td class="text-end">
                    <Link :href="route('bhp.zestawy.asekuracyjne.edit', zestaw.id)"
                          class="btn btn-primary btn-sm mb-2 me-2 mt-2"><i class="bi bi-pencil-square me-2"></i>Edycja
                    </Link>
                    <button class="btn btn-sm btn-danger mb-2 me-2" @click="deleteZestaw(zestaw.id)"><i
                        class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="isModalOpenAdd" class="modal fade show" style="display: block;">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Dodaj zestaw</h5>
                <button type="button" class="btn-close" @click="closeModal"></button>
              </div>
              <div class="modal-body">
                <div class="row mb-2" v-for="type in [1,2,3]" :key="type">
                  <div class="col-md-12">
                    <label class="form-label">{{ selectLabel(type) }}</label>
                    <select v-model="selectedElements[type]" class="form-select">
                      <option value="">Wybierz</option>
                      <option v-for="el in getAvailableForType(type)" :key="el.id" :value="el.id">
                        {{ el.nr_seryjny }} - {{ formatDate(el.data_produkcji) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeModal">Anuluj</button>
                <button class="btn btn-primary" @click="saveZestaw">Dodaj</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import ubraniaMenu from "@/Pages/BHP/parts/ubraniaMenu.vue";
import {Link} from "@inertiajs/vue3";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  props: {
    zestawy: Array,
    elementy: Array,
    users: Array,   
  },
  data() {
    return {
      hasPermission,
      isModalOpenAdd: false,
      editedZestaw: null,
      selectedElements: {1: null, 2: null, 3: null},
      currentZestaw: null,
    };
  },
  components: {AppLayout, Link, ubraniaMenu},

  methods: {
    selectLabel(type) {
      switch (type) {
        case 1:
          return 'Szelki';
        case 2:
          return 'Lina';
        case 3:
          return 'Zatrzaśnik';
        default:
          return '';
      }
    },
    getAvailableForType(type) {
      let currentId = null;
      if (this.editedZestaw) {
        switch (type) {
          case 1:
            currentId = this.editedZestaw.szelki?.id;
            break;
          case 2:
            currentId = this.editedZestaw.lina?.id;
            break;
          case 3:
            currentId = this.editedZestaw.zatrzasnik?.id;
            break;
        }
      }
      const usedIds = new Set();
      this.zestawy.forEach(z => {
        if (z.szelki?.id) usedIds.add(z.szelki.id);
        if (z.lina?.id) usedIds.add(z.lina.id);
        if (z.zatrzasnik?.id) usedIds.add(z.zatrzasnik.id);
      });
      return this.elementy.filter(el =>
          el.rodzaj == type && (!usedIds.has(el.id) || el.id === currentId)
      );
    },
    openModal(zestaw = null) {
      this.isModalOpenAdd = true;
      this.editedZestaw = zestaw;
      if (zestaw) {
        this.selectedElements = {
          1: zestaw.szelki?.id || null,
          2: zestaw.lina?.id || null,
          3: zestaw.zatrzasnik?.id || null
        };
      } else {
        this.selectedElements = {1: null, 2: null, 3: null};
      }
    },
    saveZestaw() {
      const payload = {
        szelki_id: this.selectedElements[1],
        lina_id: this.selectedElements[2],
        zatrzasnik_id: this.selectedElements[3],
      };
      this.$inertia.post(route('bhp.zestawy.asekuracyjne.add'), payload, {onSuccess: () => this.closeModal()});
    },
    closeModal() {
      this.isModalOpenAdd = false;
      this.editedZestaw = null;
    },
    deleteZestaw(id) {
      if (!confirm('Czy na pewno chcesz usunąć zestaw?')) return;
      this.$inertia.delete(route('bhp.zestawy.asekuracyjne.delete', id));
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('pl-PL');
    }
  }
};
</script>

<style scoped>
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}
table th, table td {
  min-width: 50px;
  height: 32px;
}
.tooltip {
  opacity: 1 !important;
}

.table tbody tr:nth-child(even) td:not([style*="background-color"]) {
  background-color: #f9f9f9 !important;
}

.table tbody tr:nth-child(odd) td:not([style*="background-color"]) {
  background-color: #ffffff !important;
}

/* hover nadal działa, ale tylko na niekolorowanych komórkach */
.table tbody tr
:hover td:not([style*="background-color"]) {
  background-color: #eaeaea !important;
}

</style>
